import { render } from "./Permit.vue?vue&type=template&id=2a752f0d&scoped=true"
import script from "./Permit.vue?vue&type=script&lang=js"
export * from "./Permit.vue?vue&type=script&lang=js"

import "./Permit.vue?vue&type=style&index=0&id=2a752f0d&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a752f0d"]])

export default __exports__